import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export const useDeleteAllProviders = ({
  enrollmentEventId,
}: {
  enrollmentEventId: string;
}) => {
  return useMutation<void, GrapeAPIErrorType, void>({
    mutationFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/providers/delete_all`,
        {
          method: 'DELETE',
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
          requestId: response.headers.get('x-request-id') ?? undefined,
        })
      }
    }
  })
}
